module.exports = __webpack_public_path__ + "static/media/tiktok.bc3a3e58.svg";